import styled from "styled-components"

export const StyledLeftArrow = styled.p`
  padding: 0 20px;
`
